module.exports = __webpack_public_path__ + "img/sleep.6ed33d4a.svg";